import { ValueTagProps } from './value-tag.types'
import styles from './value-tag.module.scss'
import cl from 'classnames'
import { Button, IconDelete, Text2 } from '@touche-lts/panel-ui/dist'

const ValueTagComponent = (props: ValueTagProps) => {
  const { className, style, valueName, color, removable, onRemove } = props

  return (
    <div className={cl(styles.container, className)} style={style}>
      {color && (
        <span className={styles.colorDot} style={{ backgroundColor: color }} />
      )}
      <Text2 colorPreset='dark'>{valueName}</Text2>
      {removable && onRemove && (
        <Button
          preset='icon'
          className={styles.deleteButton}
          onClick={onRemove}
        >
          <IconDelete />
        </Button>
      )}
    </div>
  )
}

const ValueTag = ValueTagComponent
export { ValueTag }
